module.exports = __webpack_public_path__ + "1c66c64bc30512b50a9f7654babc2a1e.svg";